type NativeUserState = {
  homepageConfig?: { secureRoomVerificationEnabled?: boolean };
  genericQRCode?: boolean;
  attributes?: Record<string, unknown>;
};

const protectedRouteNames = new Set([
  "page_home",
  "page_facilities",
  "page_facilities_detail",
  "page_things_to_do",
  "page_thingstodo_detail",
  "page_promotion",
  "page_basic",
  "page_hotel_info",
  "page_activity",
  "page_assistance",
  "page_buggy",
]);

function storedRoomNumber(): string {
  try {
    const value = JSON.parse(localStorage.getItem("VCquery") || "{}");
    return value?.VCquery?.user_room_number || "";
  } catch {
    return "";
  }
}

export function requiresRoomVerification(
  routeName: string | symbol | undefined,
  source: unknown,
  user: NativeUserState,
  query: Record<string, unknown> = {},
): boolean {
  if (
    typeof routeName !== "string" ||
    !protectedRouteNames.has(routeName) ||
    user.homepageConfig?.secureRoomVerificationEnabled === false
  ) {
    return false;
  }

  // Shared Assistance cards collect and verify a room at submission.
  if (
    routeName === "page_assistance" &&
    typeof query.assistanceOption === "string" &&
    query.roomEntry === "generic"
  )
    return false;

  if (user.genericQRCode) return Boolean(localStorage.getItem("error"));
  if (source === "dc") return false;

  return !(
    storedRoomNumber() ||
    user.attributes?.user_room_number ||
    user.attributes?.["user_room_number"]
  );
}
